export type ContactAreaType = {
  areaType?: AreaType;
  districts?: (string | number)[][];
  contacts?: Contact[];
};

export type Contact = {
  id: number;
  name: string;
  companyName: string;
  role: string;
  address1: string;
  address2?: string;
  address3?: string;
  picture: string;
  phone?: string;
  mobile?: string;
  fax: string;
  email: string;
  contactFormUrl?: string;
  headquarter: boolean;
  echains: boolean;
  íglidur: boolean;
};

export enum AreaType {
  DISTRICT = 'District',
  POSTCODE = 'Postcode',
  CONTACTS = 'Contacts',
  NONE = 'None',
}
